import useInitializeSocket from './useInitializeSocket';
import useUserStatus from './useUserStatus';
import useNotifications from './useNotifications';

const useSocket = (empCode, initialStatus) => {
  const socket = useInitializeSocket();
  const { updateStatus } = useUserStatus(socket, empCode, initialStatus);
  useNotifications(socket);

  return { socket, updateStatus };
};

export default useSocket;
